import React from "react";
import { Link as RouterLink } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";

import { routePaths } from "./route-paths";

interface MainListItemsProps {
  pathname: string;
}

const getCurrentMenuItemIdFromPathname = (pathname: string): string => {
  if (pathname.startsWith("/dashboard")) return "dashboard";
  return "";
};

const createMenuItems = () => {
  return [
    {
      id: "dashboard",
      primary: "Dashboard",
      to: routePaths.dashboard.root,
      icon: DashboardIcon,
    },
  ];
};

const MainMenuList = (props: MainListItemsProps) => {
  const { pathname } = props;
  let menuItems = createMenuItems();
  let currentMenuItemId = getCurrentMenuItemIdFromPathname(pathname);

  return (
    <List>
      {menuItems.map((menuItem) => (
        <ListItemButton
          key={menuItem.id}
          component={RouterLink}
          to={menuItem.to}
          selected={currentMenuItemId === menuItem.id}
        >
          <ListItemIcon>
            <menuItem.icon />
          </ListItemIcon>
          <ListItemText primary={menuItem.primary} />
        </ListItemButton>
      ))}
    </List >
  );
};

export default MainMenuList;
